/**
 * @module categories ("factors")
 */
import { createReducer } from '@reduxjs/toolkit';
import { categoryActions } from '~/behaviors/actions/category.actions';
import { surveyTypeActions } from '~/behaviors/actions/survey_type.actions';
import { taskTemplateActions } from '~/behaviors/actions/task_template.actions';
import { taskActions } from '~/behaviors/actions/task.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

/**
 * Iterate over each element of `action.payload.categories` and merge each with any
 * existing entity with the same ID in the state (or create new one if none exist).
 */
const mergeCategories = (state, action) => {
  const categories = action?.payload?.entities?.categories || {};

  Object.values(categories).forEach((newCategory) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const currentCategory = state[newCategory.id] || {};

    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    state[newCategory.id] = {
      ...currentCategory,
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...newCategory,
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      name: newCategory.name ? newCategory.name : currentCategory.name || '',
    };
  });
};

const deleteCategory = (state, action) => {
  const id = action?.payload?.id;

  if (id) {
    const { [id]: _deletedCategory, ...remainingCategories } = state;

    return remainingCategories;
  }
};

const categories = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);
  builder.addCase(taskActions.fetchTaskList.fulfilled, mergeCategories);
  builder.addCase(taskActions.fetchTask.fulfilled, mergeCategories);
  builder.addCase(taskTemplateActions.fetchTaskTemplateList.fulfilled, mergeCategories);
  builder.addCase(taskTemplateActions.fetchTaskTemplate.fulfilled, mergeCategories);

  builder.addCase(surveyTypeActions.fetchSurveyTypesWithCategories.fulfilled, mergeCategories);

  builder.addCase(surveyTypeActions.createSurveyType.fulfilled, mergeCategories);
  builder.addCase(categoryActions.createCategory.fulfilled, mergeCategories);
  builder.addCase(categoryActions.updateCategory.fulfilled, mergeCategories);
  builder.addCase(categoryActions.removeCategory.fulfilled, deleteCategory);
});

export default categories;
